module.exports = __webpack_public_path__ + "media/Video 95.6fded63e.mp4";